// Datasets that are never legitimately empty once loaded. The API helpers
// swallow errors (timeouts, 5xx, token refresh) and return undefined or [],
// so an empty answer for these means "the refresh failed", not "no data".
export const KEEP_PREVIOUS_WHEN_EMPTY = new Set([
  "positions",
  "previousDay",
  "arbMonitorData",
  "bondMonitorData",
  "securitiesData",
  "strategyRegionsData",
  "strategyAllowedRegionsData",
]);

// True when a refresh answer should be ignored in favour of what is already
// loaded: nothing came back, or a never-empty dataset came back empty.
export const isFailedRefresh = (key, response, previous) =>
  response == null ||
  (KEEP_PREVIOUS_WHEN_EMPTY.has(key) &&
    Array.isArray(response) &&
    response.length === 0 &&
    previous?.length > 0);
